import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StatusMenuStylesProps = {
  colour?: string
  disabled?: boolean
}

const useStyles = makeStyles<Theme, StatusMenuStylesProps>(theme => ({
  root: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    fontSize: theme.size.sm,
    color: theme.palette.textAlt,
    marginBottom: '0.25rem',

    [theme.breakpoints.down('lg')]: {
      fontSize: theme.size.sm,
      color: theme.palette.textLight
    }
  },

  icon: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    marginLeft: '7px',
    height: 'auto',
    width: '10px',
    opacity: '0.7'
  },

  name: {
    marginBottom: '0.5rem',
    cursor: 'default'
  }
}))

export default useStyles
